export const IVL_INVENTORY_FLAG = 'feature.ivlInventoryStatus'
export const IVL_INVENTORY_PAGE_SIZE = 200
export const IVL_INVENTORY_EXPORT_LIMIT = 30_000
export const IVL_INVENTORY_DISPLAY_COUNT_CAP = 1000
/** hasMore 미지원 구 응답은 서버에서 100,000건까지만 센다. */
export const IVL_INVENTORY_COUNT_CAP = 100_000
// Spec: docs/spec/inventory/SPEC-inventory-ivl-excel-export-A.yaml#ivl-excel-request-timeout-is-270s
export const IVL_INVENTORY_EXPORT_TIMEOUT_MS = 270_000
